export enum StatusLoteRolloutFuncionarios {
  /** Planilha cadastrada, validação não iniciada */
  CREATED = 'CREATED',
  /** Iniciou a validação */
  VALIDATING = 'VALIDATING',
  /** Finalizou com todos inválidos */
  INVALID = 'INVALID',
  /** Terminou com ao menos 1 item válido */
  OPEN = 'OPEN',
  /** Agendado para processamento futuro */
  SCHEDULED = 'SCHEDULED',
  /** Cliente cancelou o lote */
  CANCELLED = 'CANCELLED',
  /** Lote fechado e aguardando processamento */
  WAITING_PROCESSING = 'WAITING_PROCESSING',
  /** Iniciou etapa de processamento */
  PROCESSING = 'PROCESSING',
  /** Todos os itens processados com falha */
  FAILED = 'FAILED',
  /** Com ao menos 1 item processado com sucesso */
  FINISHED = 'FINISHED',
}
